import { comparatorPayloadGeneration as comparatorPayloadGenerationIT } from './IT/comparatorPayloadGeneration'

const payloadGeneratorByCountry = {
  it: comparatorPayloadGenerationIT,
}

export const buildComparatorPayload = ({ country, ...params }) => {
  const generator = payloadGeneratorByCountry[country] ?? null

  if (!generator) {
    throw new Error(`buildComparatorPayload: unsupported country '${country}'`)
  }

  return generator({ country, ...params })
}
